import { IEnvironment } from './types'
import localEnv from './data/local.json'

const loadAppEnvironment = async (): Promise<IEnvironment> => {
  try {
    const response = await fetch(
      `./assets/configuration/configuration.json?t=${new Date().getTime()}`,
    )
    const remoteEnv = (await response.json()) as IEnvironment

    remoteEnv.debugEnabled = remoteEnv.name === 'development'

    return remoteEnv
  } catch {
    console.warn(
      'Error when trying to load remote environment. Trying to use local environment instead.',
    )
    return localEnv as IEnvironment
  }
}

export default await loadAppEnvironment()
